import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getPerformance = async (filters = {}) => {
  const response = await axios.get(`${base_url}performance`, config);
  return response.data;
};

const updatePerformanceStatus = async (id, status) => {
  const response = await axios.put(
    `${base_url}performance/update-status/${id}?status=${status}`,
    {},
    config
  );
  return response.data;
};

const performanceService = {
  getPerformance,
  updatePerformanceStatus,
};

export default performanceService;
